import React from 'react';
import { graphql, useFragment } from 'react-relay';
import type { ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_featuresRef$key } from '@atlassian/jira-relay/src/__generated__/ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_featuresRef.graphql';
import type { ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef$key } from '@atlassian/jira-relay/src/__generated__/ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef.graphql';
import { LandingPage } from './main';

export const VirtualAgentLanding = ({
	featuresRef,
	projectRef,
}: {
	featuresRef: ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_featuresRef$key;
	projectRef: ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef$key;
}) => {
	const featuresData = useFragment(
		graphql`
			fragment ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_featuresRef on VirtualAgentFeatures
			@argumentDefinitions(checkForAiEnabledFF: { type: "Boolean!" }) {
				...main_servicedeskSettingsVirtualAgentLanding_LandingPage_featuresRef
					@arguments(checkForAiEnabledFF: $checkForAiEnabledFF)
			}
		`,
		featuresRef,
	);

	const projectData = useFragment(
		graphql`
			fragment ui_servicedeskSettingsVirtualAgentLanding_VirtualAgentLanding_projectRef on JiraProject {
				...main_servicedeskSettingsVirtualAgentLanding_LandingPage_projectRef
			}
		`,
		projectRef,
	);

	return <LandingPage featuresRef={featuresData} projectRef={projectData} />;
};
